import React from 'react'
import styled from 'styled-components'

import media from 'styles/media'

import links from 'utils/links'

import WatchNow from 'components/buttons/WatchNow'
import NavLink from 'components/Header/NavLink'

import LogoSVG from 'assets/images/logo.svg'

const Header: React.FC = () => {

  const handleLogoClick = () => {
    window.locomotiveScroll.scrollTo(0)
  }

  return (
    <Wrapper>
      <Left>
        <LogoWrapper onClick={handleLogoClick} >
          <Logo src={LogoSVG} alt="FreshCut Logo" loading="lazy"/>
        </LogoWrapper>
        <LinkWrapper><NavLink href={links.home}>Litepaper</NavLink></LinkWrapper>
        <NavLink href={links.home}>FAQs</NavLink>
      </Left>
      <WatchNow />
    </Wrapper>
  )
}

export default Header

const Wrapper = styled.header`
  width: 100%;
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 6.94vw;
  padding-left: 4.17vw;
  padding-right: 4.17vw;

  ${media.tablet} {
    height: 9.77vw;
    padding-left: 4.39vw;
    padding-right: 4.39vw;
  }
`

const Left = styled.div`
  display: flex;
  align-items: center;
`

const LinkWrapper = styled.div`
  margin-right: 1.39vw;

  ${media.tablet} {
    margin-right: 1.95vw;
  }
`

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  backdrop-filter: blur(1px);
  border-radius: 2px;

  height: 2.78vw;
  width: 15.42vw;
  margin-right: 4.51vw;

  ${media.tablet} {
    margin-right: 6.35vw;
  }
`
const Logo = styled.img`

  width: 13.26vw;
  height: 1.39vw;

  ${media.tablet} {
    width: 18.65vw;
    height: 1.95vw;
  }
`